import { isValidInvoiceEmail } from "../../Invoicing/CreateInvoice/createInvoiceHelpers";
import { ChamberSettingsFormState } from "./settingsData";

type ChamberGroupInsuranceBillingDetails =
  ChamberSettingsFormState["paymentsAndTaxes"]["chamberGroupInsurancePayment"]["billingDetails"];

export type ChamberGroupInsuranceBillingErrors = Partial<
  Record<keyof ChamberGroupInsuranceBillingDetails, string>
>;

type GetChamberGroupInsuranceBillingErrorsInput = {
  billingDetails: ChamberGroupInsuranceBillingDetails;
};

const requiredBillingFields: ReadonlyArray<{
  field: keyof ChamberGroupInsuranceBillingDetails;
  message: string;
}> = [
  { field: "companyName", message: "Enter the company name." },
  { field: "streetAddress", message: "Enter the street number and name." },
  { field: "city", message: "Enter the city." },
  { field: "province", message: "Enter the province or territory." },
  { field: "postalCode", message: "Enter the postal code." },
  { field: "country", message: "Select the country." },
  { field: "contactName", message: "Enter the contact name." },
  { field: "contactEmail", message: "Enter the contact email." },
  { field: "phoneNumber", message: "Enter the phone number." },
];

// Both the details dialog and Payment Options save must enforce the same
// required payer fields before sending enabled insurance settings to CAP.
export const getChamberGroupInsuranceBillingErrors = ({
  billingDetails,
}: GetChamberGroupInsuranceBillingErrorsInput): ChamberGroupInsuranceBillingErrors => {
  const errors: ChamberGroupInsuranceBillingErrors = {};
  requiredBillingFields.forEach(({ field, message }) => {
    if (!billingDetails[field].trim()) {
      errors[field] = message;
    }
  });

  if (
    billingDetails.contactEmail.trim() &&
    !isValidInvoiceEmail(billingDetails.contactEmail)
  ) {
    errors.contactEmail = "Enter a full email address, for example billing@example.com.";
  }

  return errors;
};
